import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { theme } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const icon: CSSProperties = {
  color: theme.textSecondary,
  width: 16,
  height: 16,
  marginLeft: 2,
  marginRight: 10,
  marginTop: 3,
  flexShrink: 0,
};
